import React from 'react';
import { Data } from '@alvogen/shared/components/data/Data';

export const Component = () => {
  return (
    <Data title="Data lists">
      <Data.Header title="Today" date="Nov 24, 2020 3:00 PM EST" />
      <Data.List>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="A very long label about the data">
          An unusualy long data value to display
        </Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
      </Data.List>
      <Data.Header title="After hours" date="Nov 24, 2020 3:00 PM EST" />
      <Data.List>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
      </Data.List>
      <Data.Header title="Dividend" date="Nov 24, 2020 3:00 PM EST" />
      <Data.List>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
      </Data.List>
      <Data.Header title="Share information" date="Nov 24, 2020 3:00 PM EST" />
      <Data.List>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
        <Data.Item label="Label">Value</Data.Item>
      </Data.List>
    </Data>
  );
};
